import { render, staticRenderFns } from "./add-acct.vue?vue&type=template&id=de2c54fa&scoped=true&"
import script from "./add-acct.vue?vue&type=script&lang=ts&"
export * from "./add-acct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2c54fa",
  null
  
)

export default component.exports